import SignUp from './SignUpContainer'

export default SignUp



// WEBPACK FOOTER //
// ./src/components/SignUp/index.js